import React, { useMemo } from 'react';
import cx from 'classnames';

import ProductDetailPanel from '../../ProductDetailPanel';
import InputForm from '../../../../../components/form/InputForm';
import BaseForm from '../../../../../components/form/BaseForm';
import SwitchForm from '../../../../../components/form/SwitchForm';
import ProductOption from '../ProductOption';
import Img from '../../../../../components/Img';
import { compareProductVersion } from '../../../../../lib/utils';
import { asyncSimpleModal } from '../../../../../lib/common';
import todayDeliveryBadgeIcon from '../../../../../static/images/common/today_delivery_badge_icon.png';
import {
  FULFILLMENT_PRODUCT_MANAGEMENT_TYPE_LIST,
  MAXIMUM_NUMBER_OF_PRODUCT_NUMBER_TEXT,
  MAXIMUM_NUMBER_OF_PRODUCT_STYLE_CODE_TEXT,
  PRODUCT_DETAIL_PAGE_PANEL_NAME,
  PRODUCT_DETAIL_PAGE_TYPE,
  PRODUCT_MANAGEMENT_TYPE,
} from '../../../../../constants/service/app/productConstants';
import { PAY_METHOD_TYPE } from '../../../../../constants/service/app/orderConstants';
import './ProductStockAndOption.scss';
import { isProductOptionValidForTodayDelivery } from '../../utils';

const ProductStockAndOption = (props) => {
  const {
    pageType,
    isEditable,
    form,
    initialValue,
    proInfo,
    isCompare,
    comparisonData = {},
    minimumPrice,
    ...res
  } = props;
  const { brandFeeInfoList, choiceOption, number, resetOptionAvailable, styleCode, optionKeyName } = initialValue;
  const { isOption, feeInfo, optionList } = form.getFieldsValue();

  // 상품 편집 화면에서 풀필먼트 상품일 경우 상품 옵션 토글 비활성화
  const isDisableOptionToggle = useMemo(() => {
    return !!(
      !isEditable ||
      (pageType === PRODUCT_DETAIL_PAGE_TYPE.EDIT &&
        optionList?.find((option) => FULFILLMENT_PRODUCT_MANAGEMENT_TYPE_LIST.includes(option.productManagementType)))
    );
  }, [pageType, isEditable, optionList]);

  const onChangeOptionToggle = (isOption) => {
    form.setFieldsValue({
      isOption,
    });
  };

  const setIsGift = async ({ isGift, setData }) => {
    /**
     *  가능한 결제수단 리스트
     */
    const availablePayMethodList = isGift
      ? proInfo.productPayMethodList.filter((payMethodType) => payMethodType !== PAY_METHOD_TYPE.VBANK)
      : proInfo.productPayMethodList;

    if (!availablePayMethodList.length) {
      /**
       *  가능한 결제수단이 없는 경우
       */
      await asyncSimpleModal({
        type: 'error',
        title: '안내',
        message: '결제가능한 수단이 없습니다.\n' + '상품 결제 타입을 바꾸거나, 선물 여부를 변경해주세요.',
      });
    } else setData();
  };

  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_STOCK_AND_OPTION}
      className="product-stock-and-option sub-title-primary"
      title="재고/옵션"
      subTitle="풀필먼트 상품일 경우, 오늘출발 배송이 적용됩니다."
      isCompare={isCompare}
      {...res}
    >
      <div className="panel-body">
        <InputForm
          form={form}
          className={cx(isCompare && compareProductVersion(styleCode, comparisonData.styleCode))}
          label="스타일 코드(바코드)"
          name="styleCode"
          isEditable={isEditable}
          style={{ width: 200 }}
          initialValue={styleCode}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_STYLE_CODE_TEXT}
        />

        <InputForm
          form={form}
          className={cx(isCompare && compareProductVersion(number, comparisonData.number))}
          label="제품 번호"
          name="number"
          isEditable={isEditable}
          disabled={isOption}
          style={{ width: 200 }}
          initialValue={number}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_NUMBER_TEXT}
        />

        <BaseForm
          label="오늘출발 여부"
          content={
            (!isOption && feeInfo?.productManagementType !== PRODUCT_MANAGEMENT_TYPE.ENTER) ||
            (isOption && optionList?.find((item) => isProductOptionValidForTodayDelivery(item))) ? (
              <Img className="today-delivery-badge-icon" clickAble={false} src={todayDeliveryBadgeIcon} />
            ) : (
              '-'
            )
          }
        />

        <SwitchForm
          label="상품 옵션"
          checked={isOption}
          disabled={isDisableOptionToggle}
          onChange={onChangeOptionToggle}
        />

        <ProductOption
          isOption={isOption}
          form={form}
          isEditable={isEditable}
          isCompare={isCompare}
          comparisonData={comparisonData}
          choiceOption={choiceOption}
          optionList={initialValue.optionList}
          optionKeyName={optionKeyName}
          minimumPrice={minimumPrice}
          brandFeeInfoList={brandFeeInfoList}
          resetOptionAvailable={resetOptionAvailable}
          feeInfo={initialValue.feeInfo}
          setIsGift={setIsGift}
        />
      </div>
      <div className="hidden-form">
        <InputForm form={form} type="hidden" name="isOption" initialValue={initialValue.isOption} />
      </div>
    </ProductDetailPanel>
  );
};

export default ProductStockAndOption;
